module.exports = __webpack_public_path__ + "static/img/protect_8.c3649803.png";